import { Injectable } from '@angular/core';
import { AuthRepository } from '@data/auth/auth.repository';
import { PostRecuperarSenhaDto } from '@data/auth/dto';

@Injectable()
export class RecuperarSenhaController {
  constructor(private authRepository: AuthRepository) {}

  recuperarSenha(data: PostRecuperarSenhaDto) {
    return this.authRepository.postRecuperarSenha(data);
  }
}
